var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trial-sugeons-list"},[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_vm._v(" "),_c('rp-trialsurgeontable',{attrs:{"trialSurgeons":_vm.trialSurgeons},on:{"onView":_vm.onView}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bdde110","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Clinical/TrialSurgeons.vue
// module id = null
// module chunks = 